import { Provider, symbolToken } from '@servicetitan/react-ioc';
import { FC, PropsWithChildren } from 'react';
import { Features } from './features.store';

export interface FeatureesProviderProps extends PropsWithChildren {
    value: Features;
}

export const FEATURE_TOKEN = symbolToken<Features>('FEATURE_TOKEN');

export const FeaturesProvider: FC<FeatureesProviderProps> = ({ value, children }) => (
    <Provider singletons={[{ provide: FEATURE_TOKEN, useValue: value }]}>{children}</Provider>
);
